export const warningStyle = {
  background: "#F2994A",
};

export const fieldNameStyle = {
  color: "#646C9A",
};
